import { useEffect } from 'react';
import { setBaseURL, setOrganizationId, setRecruiterTokenKey, setTokenKey, } from '@/config/axios.config';
import { useConfigContext } from '@/hoc';
export var useSetAxiosConfig = function () {
    var _a = useConfigContext().config, apiBaseUrl = _a.apiBaseUrl, tokenKey = _a.tokenKey, organizationId = _a.organizationId, recruiterTokenKey = _a.recruiterTokenKey;
    useEffect(function () {
        setOrganizationId(organizationId);
    }, [organizationId]);
    useEffect(function () {
        setBaseURL(apiBaseUrl);
    }, [apiBaseUrl]);
    useEffect(function () {
        setTokenKey(tokenKey);
    }, [tokenKey]);
    useEffect(function () {
        setRecruiterTokenKey(recruiterTokenKey);
    }, [recruiterTokenKey]);
};
